import { z } from "zod";
import { TDate } from "../common/date";
import { TObjectBase } from "../base";

export type IUserDeviationNotificationType = z.infer<
  typeof TUserDeviationNotificationType
>;
export const TUserDeviationNotificationType = z.enum([
  "deviationReminder",
  "deviationReport",
  "deviationUpdates",
]);

export type IUserEmailNotificationType = z.infer<
  typeof TUserEmailNotificationType
>;
export const TUserEmailNotificationType = z.enum([
  "activityReminders",
  "deviationReminder",
  "deviationReport",
  "deviationUpdates",
  "postCreated",
]);

export type IUserPushNotificationType = z.infer<
  typeof TUserPushNotificationType
>;
export const TUserPushNotificationType = z.enum([
  "activityReminders",
  "chatNewGroup",
  "chatNewMessage",
  "deviationReminder",
  "deviationReport",
  "deviationUpdates",
  "newEventAttendee",
  "newPost",
  "reportAvailable",
]);

export type IUserNotificationPlatform = z.infer<
  typeof TUserNotificationPlatform
>;
export const TUserNotificationPlatform = z.union([
  z.literal("disabledEmailNotifications"),
  z.literal("disabledPushNotifications"),
]);

export type IUserDisabledEmailNotificationSettings = z.infer<
  typeof TUserDisabledEmailNotificationSettings
>;
export const TUserDisabledEmailNotificationSettings = z.record(
  z.string(),
  z.boolean()
);

export type IUserDisabledPushNotificationSettings = z.infer<
  typeof TUserDisabledPushNotificationSettings
>;
export const TUserDisabledPushNotificationSettings = z.record(
  z.string(),
  z.boolean()
);

export const TUserNotification = z
  .object({
    sendDate: TDate,
    type: z.number(),
    read: z.boolean().default(false),
    notificationData: z
      .object({
        title: z.string().optional(),
        body: z.string().optional(),
      })
      .optional(),
  })
  .extend(TObjectBase.shape);
export type IUserNotification = z.infer<typeof TUserNotification>;
